import React, { useEffect, useState } from "react";
import { RSelect } from "../Component";
import { ServerStatusType } from "../../utils";

export const StatusActiveDropDown = ({ value, isForCarer = false, isMulti = false, isShowAll = true, onSelect, placeholder, ...props }) => {
  const [list, setList] = useState();

  useEffect(() => {
    return () => {
      setList();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {

    let statusValues = [
      { id: 1, label: "Active", value: ServerStatusType.active },
      { id: 2, label: "Inactive", value: ServerStatusType.disabled },
    ];
    
    if (isForCarer) {
      statusValues.push({ id: 3, label: "On Hold", value: ServerStatusType.onHold });
    }

    if (isShowAll) {
      const allOption = { id: 0, label: "All", value: "" };
      setList([allOption, ...statusValues]);
    } else {
      setList(statusValues);
    }
  }, [isShowAll]);

  return (
    <RSelect
      options={list ?? []}
      isMulti={isMulti}
      placeholder={placeholder}
      value={value ?? (isShowAll ? (list ? list[1] : null) : null)}
      onChange={(e) => {
        onSelect(e);
      }}
      {...props}
    />
  );
};
